module.exports = __webpack_public_path__ + "static/img/bus-battery.241059e5.png";